import styled from 'styled-components';
import { rem } from 'polished';
import { VehicleDetailsHeadingInformationStyled } from '../VehicleDetailsHeadingInformationStyled';
export const VehicleDetailsHeadingInformationStyledOV = styled(VehicleDetailsHeadingInformationStyled)`
    .information > .titleWithBenefits {
        .title {
            font-size: ${rem('24px')};
        }

        .specs .specs-title {
            font-size: ${rem('16px')};
        }

        .show-characteristics-button {
            width: fit-content;
            display: flex;
            flex-direction: row-reverse;
            position: relative;

            .link {
                font-size: ${rem('16px')};
            }

            .icon-wrapper {
                margin-right: ${rem('10px')};

                svg {
                    width: unset;
                }
            }

            &:hover {
                .link {
                    border-bottom: none;
                }

                &:after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background-color: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
